import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface ModuleErrorDisplayProps {
    errorMessage: string;
    moduleTitle: string;
    hasPreviousVersions?: boolean;
}

export const ModuleErrorDisplay: React.FC<ModuleErrorDisplayProps> = ({
    errorMessage,
    moduleTitle,
    hasPreviousVersions = false,
}) => {
    return (
        <Alert variant="warning" className="mb-0">
            <Row>
                <Col md={12}>
                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                    <strong>Error Loading {moduleTitle}</strong>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col md={12}>
                    <div className="error-message">
                        {errorMessage}
                    </div>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col md={12} className="text-muted">
                    <small>
                        Try using the regenerate button above to create a new version.
                        {hasPreviousVersions && (
                            <> Previous versions may be available - click the date above to view version history.</>
                        )}
                    </small>
                </Col>
            </Row>
        </Alert>
    );
};
